<template>
    <div class="fonts">
        <p class="font-opensans">Open Sans</p>
        <div v-for="(font,i) in fonts" v-if="i < 30">
                <p :class="'font-'+font.fontFamily.replace(/ /g,'').toLowerCase()">{{ font.fontFamily }}</p>
        </div>

    </div>
</template>

<script>

import WebSoc from '../utils/WebSoc.js';
import { mapActions } from 'vuex';

export default {
    name: 'fonts',
    data () {
       return {
           fonts: []
       }     
    },
    mounted () {

        document.fonts.ready.then(() => {
            console.log('fonts loaded 1')
        });
        WebSoc.SEND('search',{ DB: 'google-fonts', find: {} },fonts => {
            console.log('fonts',JSON.stringify(fonts).length);
            localStorage.fonts = JSON.stringify(fonts);
            
            return;

            //this.fonts = fonts;
            fonts.forEach((font,i) => {
                if ( !font.variants ) return console.log('!font.variants',Object.keys(font));

                //font.href = 'https://fonts.googleapis.com/css2?family='+font.fontFamily.replace(/ /g,'+')

                font.css = ".font-"+(font.fontFamily.replace(/ /g,'').toLowerCase())+"{font-family:'"+font.fontFamily+"'}"
                
                return WebSoc.SEND('update',{ DB: 'google-fonts', _id: font._id, update: { $set: { css: font.css } } },() => console.log('saved',i,font.fontFamily));

                style.textContent += font.css;

                setTimeout(() => {
                    
                    if ( style.parentElement ) return console.log('already');
                    document.head.appendChild(style);
                    console.log('added to head')
                },5000 + ( i * 1000 ));

                return;

                font.variants.forEach(family => {
                
                family.cssName = font.fontFamily.replace(/ /g,'').toLowerCase()
                
                family.css = ".font-"+(family.cssName)+"{font-family:'"+font.fontFamily+"'}"
                if ( !family.url ) return;
                family.id = ['font',font.fontFamily,family.fontStyle,family.fontWeight].join('-').replace(/ /g,'').toLowerCase();
                return;
                /*
                this.addHead({
                    id: family.id,
                    t: 'link',
                    href: family.url,
                    rel: 'stylesheet' 
                });
                */
                if ( document.head.querySelector('style#'+family.id) ) return;
                var style = document.createElement('style');
                    style.id = family.id;
                    style.innerHTML = ".font-"+(family.cssName)+" { \n\tfont-family:'"+font.fontFamily+"'\n};";
                    style.innerHTML += '\n@font-face { \n\tfont-family:"'+font.fontFamily+'";\n\tsrc: url("'+family.url+'" format("woff");\n\tfont-style:'+family.fontStyle+';\n\tfont-weight:'+family.fontWeight+'\n}';
                    document.head.appendChild(style);
                    console.log('style.innerHTML',style.innerHTML);
                })
            })
        })
    },
    methods: {
        ...mapActions([
            'addHead'
        ])
    }
}

</script>

<style lang="scss">
/*    
.font-zhimangxing { 
	font-family: 'Zhi Mang Xing';
};

.font-zillaslab,.pat {
    font-family: 'Zilla Slab';
}
.font-opensans {
    font-family: 'Open Sans';
}
.font-zhimangxing{font-family:'Zhi Mang Xing'};
@import url('https://fonts.googleapis.com/css2?family=Zhi+Mang+Xing:wght@0,400&display=swap')
@import url('https://fonts.googleapis.com/css2?family=Zhi+Mang+Xing:wght@0,400&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Zhi+Mang+Xing:wght@0,400&display=swap');

@import url('https://fonts.googleapis.com/css2?family=Zhi+Mang+Xing&display=swap');

@import url('https://fonts.googleapis.com/css2?family=Zilla+Slab:ital,wght@0,300;1,400&display=swap');

@import url('https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,600;0,700;0,800;1,300;1,400;1,600;1,700;1,800&display=swap');
*/
/*
@font-face { 
	font-family: "Zhi Mang Xing";
	src: url("https://fonts.gstatic.com/s/zhimangxing/v5/f0Xw0ey79sErYFtWQ9a2rq-g4aAnfA.woff2") format("woff");
	font-style: normal;
	font-weight: 400;
} 
*/   
</style>